var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-100"},[(_vm.is_loading)?_c('div',{staticClass:"animated-background"},[_c('div',{staticClass:"background-masker"})]):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.is_loading),expression:"!is_loading"}]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }